import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CaremapNotesModelFactory } from '../notes/model/CaremapNotesModelFactory';
import { IonFooter } from '@ionic/react';
import { CommentEditor } from './CommentEditor';
import { INoteInteractionSurface } from '../notes/reactions/INoteInteractionSurface';

// The comment bar pinned to the bottom of a note view. It renders nothing until the note has resolved.
export const CommentFooter: React.FC<{
    noteId: string;
    autoFocus?: boolean;
    surface: INoteInteractionSurface;
    authenticatedRedirect: string;
    // Called after the server has answered that the note is gone and it has left the list. A host
    // whose note view does not leave on its own (the query-param drawer) closes itself here; the care
    // map route host leaves through the note body's own handling and passes nothing.
    onNoteGone?: () => void;
}> = ({ noteId, autoFocus, surface, authenticatedRedirect, onNoteGone }) => {

    const factory = useInstance(CaremapNotesModelFactory);
    useSubscription(() => factory);

    const noteModel = factory.forActiveCaremap();
    const note = noteModel.getNote(noteId);

    if (!note) {
        return null;
    }

    const onNotFound = () => {
        noteModel.localDeleteNote(note);
        onNoteGone?.();
    };

    return (
        <IonFooter style={{padding: 8, paddingLeft: 12}} data-type="comment-footer">
            <CommentEditor
                note={note}
                onNotFound={onNotFound}
                autoFocus={autoFocus}
                surface={surface}
                authenticatedRedirect={authenticatedRedirect}
            />
        </IonFooter>
    );
};
